module.exports = __webpack_public_path__ + "1f2bf5563b9acf6b7993cd7e5aef77d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/1290_funds.png
// module id = 1601
// module chunks = 0